import React from 'react';
import { Text } from '@common/components';
import { ColorsType } from '@common/tokens';

export type ShiftState = 'rejected' | 'expired' | 'confirmed' | 'claimed';

export const COLOR_STYLE_MAP: Record<ShiftState, ColorsType> = {
  rejected: 'coral',
  expired: 'midnightLighter',
  confirmed: 'meadow',
  claimed: 'sunDarker',
};

export const WorksShiftState = ({ state }: { state: ShiftState }) => (
  <Text weight="bolder" color={COLOR_STYLE_MAP[state]}>
    {state}
  </Text>
);
